import React from 'react'
import {SlotComponent} from '../../types/ui'
import {Stack} from '../../vanilla'
import LazyLoad from 'react-lazyload'
import {Recommender} from '../recommendations'
import {ProductCategoryCarousel} from '../product-category-carousel'
interface ProductCategoryCarouselProps {
  showProductCategoryCarousel?: boolean
  title?: string
  category?: {
    name?: string
    id?: string
  }
}

interface RecommenderCarouselProps {
  showRecommender?: boolean
  title?: string
  einstein?: {
    recommenderId?: string
  }
  category?: {
    name?: string
    id?: string
  }
}

interface ProductCarouselProps {
  recommenderCarousel?: RecommenderCarouselProps
  productCategoryCarousel?: ProductCategoryCarouselProps
}

export const ProductMerchandisingCarousel: SlotComponent<ProductCarouselProps> = ({content}) => {
  if (!content) {
    return null
  }
  const {recommenderCarousel, productCategoryCarousel} = content
  return (
    <Stack>
      {recommenderCarousel?.showRecommender && recommenderCarousel?.einstein &&  (
        <LazyLoad once>
          <Recommender
            name={recommenderCarousel?.title}
            recommender={recommenderCarousel?.einstein?.recommenderId ?? ''}
            categoryId={recommenderCarousel?.category?.id}
          />
        </LazyLoad>
      )}
      {productCategoryCarousel?.showProductCategoryCarousel && (
        <ProductCategoryCarousel
          title={productCategoryCarousel?.title}
          categoryId={productCategoryCarousel?.category?.id}
        />
      )}
    </Stack>
  )
}
